// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__33f6e","currentProductCard":"styles_currentProductCard__1k7u-","cardButton":"styles_cardButton__2GDd0","icon":"styles_icon__2TjcY"};